<ion-tabs [class.web]="isWeb()">
  @if (!isWeb()) {
    <!-- Checkout button -->
    @if (cartVisible()) {
      <div class="checkout">
        <div class="checkout-button">
          <app-checkout-button (click)="showCart()" [itemCount]="combinedItemCount()"></app-checkout-button>
        </div>
      </div>
    }
    <ion-tab-bar slot="bottom">
      <ion-tab-button tab="home" href="/tabs/home">
        <ion-icon aria-hidden="true" name="home-sharp"></ion-icon>
        <ion-label>Home</ion-label>
      </ion-tab-button>
      <ion-tab-button tab="browse" href="/tabs/browse">
        <ion-icon aria-hidden="true" name="search"></ion-icon>
        <ion-label>Browse</ion-label>
      </ion-tab-button>
      <ion-tab-button tab="my-scripts" href="/tabs/my-scripts" #addScriptTab>
        <ion-icon aria-hidden="true" [src]="'assets/icons/add-script' + (addScriptTab.selected ? '-active' : '') + '.svg'"></ion-icon>
        <ion-label>My Scripts</ion-label>
      </ion-tab-button>
      <ion-tab-button tab="orders" href="/tabs/orders">
        @if (activeOrderCount() > 0) {
          <div class="counter"><span>{{ activeOrderCount() }}</span></div>
        }
        <ion-icon aria-hidden="true" name="cart"></ion-icon>
        <ion-label>Orders</ion-label>
      </ion-tab-button>
      <ion-tab-button tab="account" href="/tabs/account">
        <ion-icon name="person"></ion-icon>
        <ion-label>Account</ion-label>
      </ion-tab-button>
    </ion-tab-bar>
  }
</ion-tabs>

<app-on-startup-modal />